package ru.chm.gradereport.ui.screens.course.sheet

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredWidth
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import ru.chm.gradereport.model.HomeworkDto
import ru.chm.gradereport.ui.components.softClickable
import ru.chm.gradereport.ui.theme.GradeTheme

@Composable
internal fun HomeworkHeader(
    homework: HomeworkDto,
    orphan: Boolean = false,
    onOpen: () -> Unit,
) {
    val colors = GradeTheme.colors
    val yellow = colors.yellowAccent
    val shape = RoundedCornerShape(8.dp)
    Column(
        modifier = Modifier
            .requiredWidth(ColMark)
            .fillMaxHeight()
            .padding(horizontal = 2.dp, vertical = HeaderBlockPadV)
            .clip(shape)
            .background(yellow.copy(alpha = if (orphan) 0.04f else 0.1f))
            .softClickable(
                onClick = onOpen,
                highlight = yellow,
                shape = shape,
                hoverAlpha = 0.16f,
                pressAlpha = 0.26f,
            )
            .padding(vertical = 8.dp, horizontal = 4.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Text(
            if (orphan) "ДЗ · старое" else "ДЗ",
            color = yellow,
            fontSize = 11.sp,
            fontWeight = FontWeight.Bold,
            letterSpacing = 0.4.sp,
        )
        Text(
            "Сдано: ${homework.submittedCount}",
            color = colors.textMuted,
            fontSize = 11.sp,
            textAlign = TextAlign.Center,
            modifier = Modifier.padding(top = 2.dp),
        )
        Text(
            homework.title,
            color = colors.textPrimary,
            fontSize = 13.sp,
            fontWeight = FontWeight.SemiBold,
            maxLines = 3,
            overflow = TextOverflow.Ellipsis,
            textAlign = TextAlign.Center,
            modifier = Modifier.padding(top = 4.dp),
        )
        Spacer(Modifier.weight(1f))
    }
}
